//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TaggedObject.js";
let d=[[[0,"Decimals",1,0],[0,"Rounding",1,0]],[],[]];
SPLM.CAM.RoundPointBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.RoundPointBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.RoundPointBuilder.Output = Object.freeze({
    "NoRounding" : "NoRounding", "Thousand" : "Thousand", "Hundred" : "Hundred", "Ten" : "Ten", "One" : "One", "Tenth" : "Tenth", "Hundredth" : "Hundredth", "Thousandth" : "Thousandth", "TenThousandth" : "TenThousandth", "HundredThousandth" : "HundredThousandth", "Millionth" : "Millionth", "TenMillionth" : "TenMillionth"});

export default SPLM;